import React from 'react';

import { PrimaryFilters as PrimaryFiltersProvider } from 'components/Filters';

import {
  FILTER_CREATED,
  FILTER_ACTIVITY,
  FILTER_ACTIVITY_TYPES,
  FILTER_STATUSES,
  FILTER_APPLICATIONS,
  FILTER_PLATFORMS,
} from 'scenes/PromoCodes/constants';

import PromoCodesFilters from './filters';

export const PRIMARY_FILTERS = [
  FILTER_CREATED,
  FILTER_ACTIVITY,
  FILTER_ACTIVITY_TYPES,
  FILTER_STATUSES,
  FILTER_APPLICATIONS,
  FILTER_PLATFORMS,
];

const PrimaryFilters = () => (
  <PrimaryFiltersProvider primary={PRIMARY_FILTERS}>
    <PromoCodesFilters.Created />
    <PromoCodesFilters.Activity />
    <PromoCodesFilters.ActivityTypes withClear={true} />
    <PromoCodesFilters.Attribution withClear={true} />
    <PromoCodesFilters.Types withClear={true} />
    <PromoCodesFilters.RewardsTypes withClear={true} />
    <PromoCodesFilters.Statuses withClear={true} />
    <PromoCodesFilters.Applications withClear={true} />
    <PromoCodesFilters.Platforms withClear={true} />
    <PromoCodesFilters.Rewards withClear={true} />
    <PromoCodesFilters.RequestedBy withClear={true} />
  </PrimaryFiltersProvider>
);

export default PrimaryFilters;
